import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers } from "../../module_auth/AuthService"
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { formatDate,getUniqNewsUrl } from "../common/BaseUtil"

export function NewsAdmin() {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")

    //뉴스 상세
    const [newsTitle, setNewsTitle] = useState("");
    const [newsContent, setNewsContent] = useState("");
    const [summary, setSummary] = useState("");
    const [updateAt, setUpdateAt] = useState("");
    const [fileSource, setFileSource] = useState("");
    const [hits, setHits] = useState(0);

    //파일
    const [fileName, setFileName] = useState("");
    const [fileFormat, setFileFormat] = useState("");
    const [uniqFileName, setUniqFileName] = useState("");
    //End 뉴스 상세

    useEffect(() => {
        let url = basePort + '/get/news/' + id
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setNewsTitle(response.newsTitle)
                setNewsContent(response.newsContent)
                setSummary(response.summary == null ? "" : response.summary)
                setUpdateAt(response.updateAt)
                setFileSource(response.fileSource)
                setHits(response.hits)
                if(response.fileName){
                    setFileName(response.fileName)
                    setFileFormat(response.fileFormat)
                    setUniqFileName(response.uniqFileName)
                }
            }).catch(error => console.log(error))
    }, []);

    let navigate = useNavigate();
    function backToList() {
        let page = localStorage.getItem("page")
        let pageList = page == null ? 1 : page
        let url = "/news_list_admin?page=" + pageList;
        navigate(url);
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>독일뉴스</span></li>
                            <li class="breadcrumb-item"><span>최신뉴스</span></li>
                        </ol>
                        <div class="container">
                            <div class="card" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                <div class="card-body">
                                    <h4 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', marginBottom: '15px' }}>{newsTitle}</h4>
                                    <div class="row" style={{ marginBottom: "30px" }}>
                                        <label class="form-label">
                                            <span>작성일 {formatDate(updateAt)} 조회수 {hits}</span>
                                        </label>
                                    </div>
                                    <p class="card-text">
                                        <span style={{ color: '#222222' }}>
                                            {parse(summary)}
                                        </span><br /><br />
                                    </p>
                                    <img
                                        //src="https://www.g-workertest.co.kr/news/news_example.png"
                                        src={getUniqNewsUrl(uniqFileName, fileFormat)}
                                        style={{ width: "400px", height: "auto" }}
                                        //class="responsive-img"
                                        alt="Card image cap" />
                                    <div class="row" style={{ marginBottom: "30px" }}>
                                        <label class="form-label">
                                            <span style={{ fontSize: '13px' }}>사진: {fileSource}</span>
                                        </label>
                                    </div>
                                    <p class="card-text">
                                        <span style={{ color: '#222222' }}>
                                            {parse(newsContent)}
                                        </span><br /><br />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="container d-flex d-sm-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center" style={{ marginTop: '15px' }}>
                            <nav>
                                <ul class="pagination">
                                    <li class="page-item text-center d-flex d-md-flex d-xxl-flex justify-content-center justify-content-md-center align-items-md-center" style={{ textAlign: 'center' }} onClick={backToList}><a class="page-link">목록</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}